import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { NbsUserService } from "src/app/services/nbs-user.service";


@Injectable()
export class LoginGuard implements CanActivate {
  constructor(private userService: NbsUserService, private router: Router, private toastrService: ToastrService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let logged = this.userService.loggedIn();
    let roleId = parseInt(sessionStorage.getItem('loginUserRoleId'));
    if (logged) {
      if (route.routeConfig.path == "**") {
        return false;
      }
      if (roleId == 2) {
        switch (route.routeConfig.path) {
          case "portal":
          case "portal-add":
          case "portal-update/:portalId":
          case "terminal-type":
          case "terminal-type-add":
          case "terminal-type-update/:terminalTypeId":
          case "contract-type":
          case "contract-type-add":
          case "contract-type-update/:contractTypeId":
          case "device-model":
          case "device-model-add":
          case "device-model-update/:deviceModelId":
          case "nbs-user":
            {
              this.toastrService.error("Sayfaya erişim yetkiniz bulunmuyor!");
              return false;
            }
        }
      }
      return true;
    }
    this.toastrService.error("Sayfaya erişim için sisteme giriş yapmalısınız!");
    this.router.navigateByUrl("/login");
    return false;
  }
}


